export default "__VITE_ASSET__Cbpdoc0m__"